<div class="fc-download-cart-body" [class.fc-download-cart-body--with-footer]="itemsCount > 0">
    <div class="fc-download-cart-empty-screen" *ngIf="itemsCount <= 0">
        <img class="fc-download-cart-empty-screen-image" src="assets/img/download-cart-empty-screen.svg" />
        <span class="fc-download-cart-empty-screen-text">{{ 'Your Download List is empty.' | translate }}</span>
        <span class="fc-download-cart-empty-screen-description">{{
            'Please proceed to a brand space and add items to your list.' | translate
        }}</span>
        <button
            fcp-button
            class="fc-download-cart-empty-screen-button"
            [size]="buttonSize.Large"
            (click)="goToMyBrands()"
        >
            {{ 'DOWNLOADS.VIEW_MY_BRANDS' | translate }}
        </button>
    </div>

    <div *ngIf="itemsCount > 0">
        <div *ngFor="let product of products; trackBy: trackByItemId; let i = index">
            <div class="fc-download-cart-item" [attr.data-e2e-hook]="'download-cart-item-' + i">
                <div class="fc-download-cart-item-image-container">
                    <div *ngIf="showProductVideoPlaceholder(product)" class="fc-download-cart-item-video-placeholder">
                        <img [src]="videoPlaceholderCameraSrc" alt="" />
                    </div>
                    <img
                        *ngIf="!showProductVideoPlaceholder(product)"
                        class="fc-download-cart-item-image-container-img"
                        [src]="product.thumb | addAuthToken"
                    />
                </div>

                <div class="fc-download-cart-item-fields">
                    <div
                        class="fc-download-cart-item-field"
                        [attr.data-e2e-hook]="'download-cart-item-' + i + '-article-number'"
                    >
                        <strong>{{ 'DOWNLOADS.ITEM_NR' | translate }}:</strong> {{ product.articleNumber }}
                    </div>
                    <div
                        class="fc-download-cart-item-field"
                        [attr.data-e2e-hook]="'download-cart-item-' + i + '-brand-name'"
                    >
                        <strong>{{ 'DOWNLOADS.BRAND' | translate }}:</strong> {{ product.brand.name }}
                    </div>
                </div>

                <div>
                    <div class="fc-download-cart-remove-button-container" data-e2e-hook="download_cart_remove_button">
                        <i class="fas fa-trash fc-download-cart-remove-button" (click)="removeProduct(product)"></i>
                    </div>
                </div>
            </div>

            <mat-divider></mat-divider>
        </div>

        <div *ngFor="let item of marketingImages; trackBy: trackByItemId; let i = index">
            <div class="fc-download-cart-item">
                <div *ngIf="item.hasPreview" class="fc-download-cart-item-image-container">
                    <img class="fc-download-cart-item-image-container-img" [src]="item.thumb | addAuthToken" />
                    <img
                        *ngIf="item.isVideoThumbnail"
                        [src]="videoOverlayIcon"
                        class="fc-download-cart-item-img-overlay"
                    />
                </div>

                <div *ngIf="!item.hasPreview" class="fc-download-cart-item-image-container">
                    <img [src]="getIconLink(item.extension)" class="img-responsive fc-download-cart-item-img-overlay" />
                </div>

                <div class="fc-download-cart-item-fields">
                    <div class="fc-download-cart-item-field">
                        <strong>{{ 'DOWNLOADS.SEASON' | translate }}:</strong> {{ getSeasonName(item) | translate }}
                        {{ getSeasonYear(item) }}
                    </div>
                    <div class="fc-download-cart-item-field">
                        <strong>{{ 'DOWNLOADS.BRAND' | translate }}:</strong> {{ item.brand.name }}
                    </div>
                </div>

                <div>
                    <div class="fc-download-cart-remove-button-container" data-e2e-hook="download_cart_remove_button">
                        <i class="fas fa-trash fc-download-cart-remove-button" (click)="removeMarketingImage(item)"></i>
                    </div>
                </div>
            </div>

            <mat-divider></mat-divider>
        </div>
    </div>
</div>

<div *ngIf="itemsCount > 0" class="fc-bulk-search-footer" [class.fc-bulk-search-footer--drawer]="isInMainContentDrawer">
    <button
        fcp-outlined-button
        class="fc-bulk-search-cancel-button-drawer"
        [size]="buttonSize.Large"
        data-e2e-hook="download_cart_clear"
        (click)="clearDownloads()"
    >
        <fcp-icon [icon]="['fal', 'trash-alt']"></fcp-icon>
        {{ 'DOWNLOADS.CLEAR' | translate }}
    </button>
    <button
        fcp-button
        class="fc-bulk-search-download-button-drawer"
        color="prominent"
        [size]="buttonSize.Large"
        data-e2e-hook="download_cart_download"
        (click)="openDownloadModal()"
    >
        <fcp-icon [icon]="['fal', 'download']"></fcp-icon>
        {{ 'ACTIONS.DOWNLOAD' | translate }}
    </button>
</div>

<fc-download-selection-modal
    [id]="downloadSelectionModalId"
    [title]="'DOWNLOAD_CONTENT_MODAL.TITLE' | translate"
    (confirmed)="onDownloadSelectionConfirmed($event)"
></fc-download-selection-modal>
